import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', onDismiss }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onDismiss) onDismiss();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const icons = {
    success: 'fas fa-check-circle',
    error:   'fas fa-exclamation-circle',
    info:    'fas fa-info-circle',
  };

  return (
    <div className={`toast toast-${type}`} role="status" aria-live="polite">
      <i className={icons[type] || icons.info} aria-hidden="true"></i>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={onDismiss} aria-label="Dismiss notification">
        <i className="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  );
};

export default Toast;
